(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-compare-brewer"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", function () {
    var brand_selector = document.getElementById('brand-selector');

    function collapseAll() {
      var collapses = document.querySelectorAll('.brand-content');
      for (let index = 0; index < collapses.length; index++) {
        var element = new bootstrap.Collapse(collapses[index], {
          toggle: true
        });
      }
    }
  

    brand_selector.addEventListener('change', function () {
      collapseAll();

      var items = document.querySelectorAll('.'+brand_selector.value);
      for (let index = 0; index < items.length; index++) {
        var element = new bootstrap.Collapse(items[index], {
          toggle: true
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-publication-reviews"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", function () {
    const site_announcements_swiper = new Swiper('#publication-reviews-slider', {
      loop: true,
      autoplay: true,
      autoplay: {
        delay: 5000,
      },
      disableOnInteraction: false,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-reviews-slider"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", function () {
    const site_announcements_swiper = new Swiper('#reviews-slider', {
      loop: true,
      autoplay: true,
      disableOnInteraction: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-roaster-quotes"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", function () {
    const roaster_swiper = new Swiper('#roaster-quote-slider', {
      loop: true,
      autoplay: false,
      disableOnInteraction: false,
      autoPlaySpeed: 8000,
      spaceBetween: 30,
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        768: {
          centeredSlides: false,
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        992: {
          centeredSlides: false,
          slidesPerView: 3,
          slidesPerGroup: 3,
        }
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init_beans();
    });
  } else {
    init_beans();
  }

  function init_beans () {
    const beans = gsap.utils.toArray(".bean");
    beans.forEach((bean, i) => {
      gsap.from(bean,
        {
          rotation: -45,
          y: -200,
          scrollTrigger: {
            trigger: bean,
            start: "center bottom",
            end: "center top",
            markers: false,
            scrub: true
          }
        }
      );
    });
  }

  } catch(e) { console.error(e); }
})();
})();
